module.exports = __webpack_public_path__ + "img/i.377d8f58.jpg";